import React from 'react'
import PropTypes from 'prop-types'
import Validator from 'validatorjs'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import TextArea from 'components/TextArea'
import Input from 'components/Input'
import Button from 'components/Button'

import { statusChanged } from 'components/RequestStatus/actions'
import { claimChanged } from 'scenes/VehicleDetail/actions'
import { CLAIM_UPDATE } from 'constants'

import './styles.scss'

export class ClaimSummary extends BaseComponent {
  static validationRules = {
    summary: 'string|required|min:4|max:1000',
  }

  constructor() {
    super()

    this.state = {
      buttonProps: {
        disabled: true
      },
      formData: {
        summary: ''  
      }
    }

    this._bind('_handleSubmit', '_handleChange', '_validate', '_renderSMSField')
  }

  _handleSubmit(e) {
    e.preventDefault()

    const formData = new FormData()
    formData.append('summary', this.state.formData.summary)

    this.props.updateRequestStatus('progress', 'Modificando datos del siniestro...')
    request(CLAIM_UPDATE(this.props.claim.id), {
      method: 'PUT',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.props.updateRequestStatus('ok', 'Datos modificados')
      this.props.claimChanged({
        ...this.props.claim,
        summary: this.state.formData.summary
      })
      this.props.onSuccess()
    }).catch((err) => {this.props.updateRequestStatus('error', 'No pudimos modificar los datos')})

    this.setState({
      editting: false
    })

  }

  _handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e.target.name, e.target.value)
  }

  _validate(name, value) {
    const formData = {
      ...this.state.formData,
      [name]: value
    }
    var rules = ClaimSummary.validationRules
    const validator = new Validator(formData, rules)
    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      }
    })
  }

  _renderSMSField() {
    var title = "SMS   " + this.state.formData['sms_content'].length + " / 160"
    return (this.props.claim.sms_enabled) ? (
      <span>
        <br></br>
        <Input  label={title}
          name="sms_content"
          placeholder="Texto SMS"
          value={this.state.formData.sms_content}
          onChange={this._handleChange} />
      </span>
    ): null
  }

  render() {
    var title = "Mensaje   " + this.state.formData['summary'].length + " / 1000"
    return (
      <div id="NewNotification" className="NewNotification Modal__content">
        <div className="NewNotification__header d-flex justify-content-between align-items-center">
          <h1>Crear notificación</h1>
          <span className="material-icons close-button" onClick={() => this.context.toggleModal(false)}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex NewNotification__form">
          <p className="instructions">El resumen ayudará al entendimiento de lo que sucedió en el siniestro al momento de leer el reporte de cierre.</p>

          <TextArea placeholder="Redactar resumen"
                    label={title}
                    name="summary"
                    value={this.state.formData.summary}
                    onChange={this._handleChange} />

          <div className="controls">
            <Button buttonType="primary" size="big" {...this.state.buttonProps}>Terminar y enviar</Button>
          </div>
        </form>
      </div>
    )
  }
}

ClaimSummary.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    claim: state.vehicleDetail.get('claim')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    claimChanged: (vehicle) => dispatch(claimChanged(vehicle))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimSummary)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/About/ClaimSummary/ClaimSummary.js